// Ship Schedule Aggregation Internationalization - English
export default {
  title: 'Ship Schedule Query (Aggregated)',
  description: 'Aggregated display of direct and transit schedules',

  // Search area
  search: {
    title: 'Ship Schedule Query',
    originPort: 'Origin Port',
    destinationPort: 'Destination Port',
    etd: 'ETD',
    searchButton: 'Search',
    selectOriginPort: 'Please select origin port',
    selectDestinationPort: 'Please select destination port',
    selectDate: 'Select date'
  },

  // Schedule type cards
  scheduleType: {
    direct: 'Direct Schedules',
    transit: 'Transit Schedules',
    vesselGroups: '{count} Vessel Groups',
    carriers: '{count} Carriers',
    schedules: '{count} Schedules',
    solutionCount: '{count} Transit Solutions'
  },

  // Filters
  filter: {
    carrier: 'Carrier',
    originTerminal: 'Origin Terminal',
    destTerminal: 'Dest Terminal'
  },

  // Schedule group
  scheduleGroup: {
    weekday: 'Schedule',
    duration: 'Duration',
    durationRange: 'Duration',
    sharedCarriers: 'Space Sharing Carriers',
    carrier: 'Carrier',
    solutionCount: 'Solutions'
  },

  // Detail tabs
  detailTabs: {
    ai: 'AI Schedule',
    localFee: 'Local Fees',
    route: 'Route Path'
  },

  // Schedule detail
  scheduleDetail: {
    vessel: 'Vessel',
    voyage: 'Voyage',
    originPort: 'Origin Port',
    destPort: 'Dest Port',
    terminal: 'Terminal',
    etd: 'ETD',
    eta: 'ETA',
    duration: 'Days',
    firstTransitPort: 'First Transit Port',
    operationTime: 'Operation Time',
    inquiry: 'Inquiry',
    matchRate: 'Match Rate',
    transitDetail: 'Transit Detail',
    loadMore: 'Click to load more schedules',
    shareCabinDetail: 'Space Sharing Detail'
  },

  // Share cabin detail modal
  shareCabinDetail: {
    title: 'Space Sharing Detail',
    durationText: 'Transit {duration} Days',
    carrier: 'Carrier',
    routeCode: 'Route Code',
    voyage: 'Voyage',
    mainCarrier: 'Main Carrier'
  },

  // Operation time modal
  operationTime: {
    title: 'Operation Time',
    bookingCutoff: 'Booking Cutoff',
    cyOpen: 'CY Open',
    cyClose: 'CY Close',
    customCutoff: 'Custom Cutoff',
    cutOff: 'Cut-off',
    siCutoff: 'SI Cutoff',
    vgmCutoff: 'VGM Cutoff',
    disclaimer: 'The above operation times are for reference only\nPlease refer to terminal and carrier announcements for actual times'
  },

  // Transit detail modal
  transitDetail: {
    title: 'Transit Detail',
    transit1Port: 'Transit Port 1',
    transit1Route: 'Transit 1 Route Code',
    transit1Vessel: 'Transit 1 Vessel/Voyage',
    transit2Port: 'Transit Port 2',
    transit2Route: 'Transit 2 Route Code',
    transit2Vessel: 'Transit 2 Vessel/Voyage',
    vesselVoyage: 'Vessel/Voyage',
    routeCode: 'Route Code',
    arrival: 'ETA',
    departure: 'ETD',
    transitBadge: 'Transit'
  },

  // Route path
  route: {
    startPort: 'Start Port',
    endPort: 'End Port',
    transitPort: 'Transit Port',
    days: 'Days'
  },

  // Local fees
  localFee: {
    feeName: 'Fee Name',
    perTicketPrice: 'Per Ticket',
    disclaimer: 'The above fees are for reference only, please refer to carrier announcements',
    gp20: '20\'GP',
    gp40: '40\'GP',
    hq40: '40\'HQ',
    hq45: '45\'HQ',
    rf20: '20\'RF',
    otfr20: '20\'OT/FR',
    rh40: '40\'RH',
    otfr40: '40\'OT/FR'
  },

  // Vessel info tooltip
  vesselInfo: {
    name: 'Vessel Name',
    imo: 'IMO',
    mmsi: 'MMSI',
    callSign: 'Call Sign',
    terminal: 'Terminal'
  },

  // Weekdays
  weekdays: {
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    Sunday: 'Sunday'
  },

  // Port selector
  portSelector: {
    emptyPorts: 'No port data available',
    other: 'Other'
  },

  // Messages
  messages: {
    selectPorts: 'Please select origin port and destination port',
    loadFailed: 'Failed to load data, please try again later',
    emptyResult: 'No data available'
  }
}
